// store/modules/onboarding.js
import { toGetOnboardingStatus } from "@/src/utils/utils.js";
import { onboardingSteps } from "@/src/constants/authConstants.js";

const state = {
  status: null,
  isLoading: false,
  error: null,
};

const mutations = {
  SET_STATUS(state, status) {
    state.status = status;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async fetchStatus({ commit, state }) {
    if (state.status !== null) return state.status;

    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const status = await toGetOnboardingStatus();
      commit("SET_STATUS", status);
      return status;
    } catch (error) {
      console.error("Error fetching onboarding status:", error);
      commit("SET_ERROR", error);
      return undefined;
    } finally {
      commit("SET_LOADING", false);
    }
  },
  resetStatus({ commit }) {
    commit("SET_STATUS", null);
  },
};

const getters = {
  isOnboardingComplete: (state) =>
    state.status === onboardingSteps.ONBOARDING_COMPLETE,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
